import { Column } from "react-table";
const ColumnSettings: Array<Column> = [
  {
    Header: "Descrizione ruolo",
    accessor: "description"
  },
  {
    Header: "Nome",
    accessor: "name"
  },
  {
    Header: "Suffisso",
    accessor: "rolePostfix"
  },
]; 
export default ColumnSettings;